import styled from '@emotion/styled';

export const Status = styled('span', {
  label: 'status',
})<{ $bg: string }>`
  width: 5.2rem;
  height: 1.5rem;
  font-size: 0.9rem;
  color: #ffffff;
  border-radius: 0.25rem;
  background-color: ${({ $bg }) => $bg};
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const MainBox = styled('div', { label: 'main-box' })`
  background-color: #ffffff;
  box-shadow: 0 0.1rem 0.1rem 0 rgba(0, 0, 0, 0.05);
  @media (orientation: landscape) {
    display: grid;
    grid-template-columns: 1fr auto;
    grid-template-rows: auto auto;
  }
`;

export const HeaderBox = styled('div', { label: 'header-box' })`
  height: 4rem;
  border-bottom: 0.05rem solid #efefef;
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;
  align-items: center;
  padding: 0 1.5rem;
  @media (orientation: landscape) {
    flex-direction: row;
    justify-content: flex-start;
    gap: 1rem;
    height: 5rem;
    border-bottom: none;
  }
`;

export const DetailBox = styled('div', { label: 'detail-box' })`
  border-bottom: 0.05rem solid #efefef;
  padding: 2rem 1.5rem;
  display: grid;
  @media (orientation: landscape) {
    border-bottom: none;
    padding-block: 0;
    grid-template-columns: 1fr 1fr;
    padding-bottom: 1.75rem;
  }
`;

export const ActionBox = styled('div', { label: 'action-box' })`
  height: 3.875rem;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  @media (orientation: landscape) {
    margin-inline: 0;
    width: 12rem;
    padding: 1.75rem 1.5rem 0;
    flex-direction: column;
    justify-content: flex-start;
    gap: 1rem;
    grid-row: 1 / 3;
    grid-column: 2 / 3;
    height: 100%;
    border-left: 0.05rem solid #efefef;
  }
`;

export const Divider = styled('div', { label: 'divider' })`
  width: 0.05rem;
  height: 1.375rem;
  background-color: #efefef;
  @media (orientation: landscape) {
    display: none;
  }
`;

export const StyledButton = styled('button', { label: 'styled-button' })`
  font-size: 0.9rem;
  color: #0063a0;
  font-weight: 500;
  border: none;
  background-color: transparent;

  &:disabled {
    color: #d9d9d9;
  }

  @media (orientation: landscape) {
    background-color: #0063a0;
    color: #ffffff;
    width: 100%;
    height: 2.25rem;
    border-radius: 0.25rem;
  }
`;
